export enum ButtonType {
  Primary = 'primary',
  PrimaryDark = 'primary-dark',
  Secondary = 'secondary',
  Confirm = 'confirm',
  Success = 'success',
  Danger = 'danger',
  Alert = 'alert',
  AlertSecondary = 'alert-secondary',
  LinkAlert = 'alert-link',
  Light = 'light',
  Dark = 'dark',
  Inverted = 'inverted',
  Link = 'link',
  LinkLight = 'link-light',
  SecondaryLink = 'secondary-link',
  PrimaryLink = 'primary-link',
  DangerLink = 'danger-link',
  PrimaryLinkLight = 'primary-link-light',
}
